module.exports = __webpack_public_path__ + "img/kayak_2021.569de2f4.jpg";